/*eslint-disable*/
import React, { useContext, useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import HyperModal from "react-hyper-modal"

import moment from "moment"
import MomentUtils from "@date-io/moment"
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import draftToHtml from "draftjs-to-html"
import { GridLoader } from "react-spinners"

// Private Component
import {
  eventDetails,
  notificationByEmailOnEventActionByMultipro,
  openClosedCompanyListByMultiproId,
  updateEvent,
  uploadNewEvent,
} from "../../api/eventAction"
import config from "../../config"
import {
  companyList,
  companyListThatCanPublish,
  uploadImageCompany,
} from "../../api/companyAction"
import JAlert from "../../components/smallComponent/jAlert"

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles"
import FormControlLabel from "@material-ui/core/FormControlLabel"

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import Switch from "@material-ui/core/Switch"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite"
import Store from "@material-ui/icons/Store"

// core components (from template)
import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"
import CustomInput from "components/CustomInput/CustomInput.js"
import Button from "components/CustomButtons/Button.js"
import Card from "components/Card/Card.js"
import CardHeader from "components/Card/CardHeader.js"
import CardText from "components/Card/CardText.js"
import CardBody from "components/Card/CardBody.js"

// Context & API
import authContext from "../../context/AuthContext"

// Styling
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import stylesExtended from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js"
import buttonStyles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import customSelectStyle from "../../assets/jss/material-dashboard-pro-react/customSelectStyle"
import customCheckboxRadioSwitch from "../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch"
import "./event.css"
import { Box, Tooltip } from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"
import {
  Drafts,
  HelpRounded,
  InfoRounded,
  InsertPhoto,
  Event,
  Schedule,
  AttachMoney,
  Description,
  Business,
} from "@material-ui/icons"
import Divider from "@material-ui/core/Divider"
import CropperX from "../../components/CropperX"
import { confirmAlert } from "react-confirm-alert"
import ArrowBack from "@material-ui/icons/ArrowBack"
import Close from "@material-ui/icons/Close"
import Warning from "@material-ui/icons/Warning"
import { compareArrayOfObject } from "../../utils/functions"
import GalleryUploader from "../../components/Medias/GalleryUploader"
import { uploadMediaToFireStorage } from "../../services/FirebaseStorageService"
import {
  saveImageMetadataBatch,
  deleteImage,
  getImageByCompany,
  getImageByEvent,
  saveImageMetadataBatchMultipleEvents,
  legacyMigrationByServerUrlToFirebase,
} from "../../api/ImageActions"
import { base64ToFileWithBlobUrl, revokeBlobUrl } from "../../utils/ImageUtils"

const localStyles = {
  mainContainer: {
    background: "linear-gradient(135deg, #667eea 0%, #0d142b 100%)",
    minHeight: "100vh",
    padding: "40px 20px",
    borderRadius: "12px",
  },
  contentWrapper: {
    maxWidth: "1400px",
    margin: "0 auto",
  },
  headerCard: {
    background: "white",
    borderRadius: "16px",
    padding: "32px",
    marginBottom: "24px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
  },
  pageTitle: {
    fontSize: "32px",
    fontWeight: "700",
    color: "#2d3748",
    marginBottom: "8px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  pageSubtitle: {
    fontSize: "16px",
    color: "#718096",
    fontWeight: "400",
    marginBottom: "0",
  },
  formCard: {
    background: "white",
    borderRadius: "16px",
    padding: "32px",
    marginBottom: "24px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "2px solid #e2e8f0",
  },
  sectionIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2d3748",
    margin: 0,
  },
  sectionNumber: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "700",
    marginRight: "12px",
  },
  infoBox: {
    background: "#eff6ff",
    border: "2px solid #bfdbfe",
    borderRadius: "12px",
    padding: "16px",
    marginBottom: "24px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  infoIcon: {
    color: "#3b82f6",
    marginTop: "2px",
  },
  infoText: {
    fontSize: "14px",
    color: "#1e40af",
    lineHeight: "1.6",
    margin: 0,
  },
  warningBox: {
    background: "#fef3c7",
    border: "2px solid #fbbf24",
    borderRadius: "12px",
    padding: "16px",
    marginBottom: "24px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  warningIcon: {
    color: "#f59e0b",
    marginTop: "2px",
  },
  warningText: {
    fontSize: "14px",
    color: "#92400e",
    lineHeight: "1.6",
    margin: 0,
  },
  backButton: {
    position: "fixed",
    right: "30px",
    top: "20px",
    zIndex: 999,
    background: "white",
    borderRadius: "10px",
    padding: "12px 24px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    border: "none",
    fontSize: "14px",
    fontWeight: "600",
    color: "#2d3748",
    transition: "transform 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  submitButton: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "16px 48px",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
    transition: "transform 0.2s, box-shadow 0.2s",
    margin: "0 auto",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
    },
  },
  visualContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  visualImage: {
    width: "100%",
    maxWidth: "400px",
    height: "auto",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
  },
  visualButton: {
    background: "#3b82f6",
    color: "white",
    padding: "12px 24px",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s",
    "&:hover": {
      background: "#2563eb",
      transform: "scale(1.05)",
    },
  },
  dateContainer: {
    background: "#f8fafc",
    padding: "20px",
    borderRadius: "12px",
    border: "2px solid #e2e8f0",
  },
  centerIt: {
    textAlign: "center",
  },
  textError: {
    color: "#f44336",
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    marginTop: "8px",
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch,
}

const disabledStyle = {
  disabledBack: {
    backgroundColor: "red",
  },
}

const useDisabledStyle = makeStyles(disabledStyle)
const useButtonStyles = makeStyles(buttonStyles)
const useLocalStyle = makeStyles(localStyles)
const useStyles = makeStyles(styles)
const useStylesExtended = makeStyles(stylesExtended)

const BASE_URL = config.BASE_URL
const CROP_AREA_ASPECT = 9 / 10
const MAX_MEDIA_GALLERY = 10
const placeHolder = require("assets/img/placeholder.jpg")

const label = {
  formTitle: "Nouvel Événement",
  formSubtitle: "Créez et configurez votre événement en quelques étapes",
  visuel: "Visuel",
  company: "société",
  companies: "Choisir un ou plusieurs établissements",
  name: "Nom de l'événement",
  description: "description",
  allTheDay: "Toute la journée (en fonction des horaires de chaque établissement)",
  dtDay: "Jour de l'événement",
  dtStart: "Heure de début",
  dtEnd: "Heure de fin",
  suspended: "Suspendu ?",
  isFree: "Gratuit",
  freely: "Gratuité",
  tarif: "Tarif",
  tarifPromo: "Tarif promo",
  eventPic: "Image de l'événement",
  draft: "brouillon",
  all: "Tous",
  none: "Aucun",
  dateError: "Vérifier les heures de votre événement.",
  tarifError: "Le tarif 'promo' doit être inférieur au tarif standard.",
  warning:
    "Attention : certains de vos établissements ont dépassé le quota journalier de publication. " +
    " (Mais il est toujours possible de modifier certains éléments)",
  publish: "Publier maintenant",
  draftBtn: "Enregistrer comme brouillon",
  visuelChoice: "Choisir une couverture",
  back: "retour",
  seeClosedOnes: "Voir les établissements fermés ce jour là ",
  closedCompanies: "Liste des Établissements fermés ce jour",
  closedCompany: "voir les établissements",
  forceItAll: "Forcer la publication et ne pas tenir compte des jours de fermeture",
  noneShopClosed: "aucun établissement fermé le jour choisi",
  section1Title: "Informations principales",
  section2Title: "Date et horaires",
  section3Title: "Tarification",
  section4Title: "Établissements concernés",
  section5Title: "Médias",
  infoMessage:
    "Remplissez tous les champs obligatoires ainsi que la photo pour publier votre événement",
  infoMedia:
    "Vous pouvez ajouter jusqu'à " +
    MAX_MEDIA_GALLERY +
    " images ou vidéos à la galerie de votre événement.",
  documentation: "Consulter la documentation",
}

export function EventManager(props) {
  let history = useHistory()
  const { mpId } = useContext(authContext)
  const [showCropper, setShowCropper] = useState(false)
  const [checked, setChecked] = useState([24, 22])
  const [multipleSelect, setMultipleSelect] = useState([])
  const [unavailableShops, setUnavailablShops] = useState([])
  const [shops, setShops] = useState([])
  const [originalShops, setOriginalShops] = useState([])
  const [forceItOverHolliday, setForceItOverHolliday] = useState(false)
  const [data, setData] = useState({
    ev_id: "",
    cname: "",
    ev_name: "",
    details: "",
    dt_from: moment().toDate(),
    dt_to:
      moment().endOf("day").toDate() >= moment().add(120, "minutes").toDate()
        ? moment().add(120, "minutes").toDate()
        : moment().endOf("day").toDate(),
    city: "",
    is_free: 0,
    tarif: 0,
    tarif_promo: 0,
    is_draft: 0,
    original_event_id: undefined,
    cids: [props.location.state?.cid ?? undefined],
    all_day: true,
    //2025 camelCase
    isFirebase: 0,
  })
  const [originalDate, setOriginalDate] = useState(undefined)
  const [dateError, setDateError] = useState(false)
  const [tarifError, setTarifError] = useState(false)
  const [dateMode, setDateMode] = useState(false)
  const [infoText, setInfoText] = useState(
    "Bravo, vos modifications ont été enregistrées"
  )
  const [subInfoText, setSubInfoText] = useState(["...et elles sont déjà actives."])
  const [showAlert, setShowAlert] = useState(false)
  const [alertType, setAlertType] = useState("success")
  const [loading, setLoading] = useState(true)
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const [modificationEvId] = useState(props.location.state?.evId ?? undefined)
  const [cid] = useState(props.location.state?.cid ?? undefined)
  const [closedMainCompanies, setClosedMainCompanies] = useState(undefined)
  const [closedCompanies, setClosedCompanies] = useState(undefined)
  const [openCompanies, setOpenCompanies] = useState(undefined)

  // Images
  const [currentImage, setCurrentImage] = useState(undefined)
  const [coverImage, setCoverImage] = useState(null)
  const [coverBlobUrl, setCoverBlobUrl] = useState(null)
  const [newCoverFile, setNewCoverFile] = useState(null)
  const [galleryImages, setGalleryImages] = useState([])
  const [pendingGalleryFiles, setPendingGalleryFiles] = useState([])
  const [imagesToDelete, setImagesToDelete] = useState([])
  const [uploadProgress, setUploadProgress] = useState(0)
  const [uploadMessage, setUploadMessage] = useState("")

  /**
   * ClosedCompanyListModal
   */
  const ClosedCompanyListModal = () => {
    const localStyles = {
      hm_hyperModalWrapper: {
        zIndex: 4,
        backgroundColor: "green",
      },
    }

    const useStyles = makeStyles(localStyles)
    const classesHM = useStyles()
    const buttonClasses = useButtonStyles()
    const classesExtended = useStylesExtended()

    return (
      <HyperModal
        isFullscreen={false}
        renderOpenButton={(requestOpen) => {
          return (
            <Button color="github" size="sm" onClick={requestOpen} simple={true}>
              <div style={{ alignContent: "center" }}>
                <Store className={buttonClasses.icons} /> {label.seeClosedOnes}
              </div>
            </Button>
          )
        }}
      >
        <GridContainer>
          <GridItem xs={12}>
            <CardBody>
              <legend>{label.closedCompanies}</legend>
              <FormControl fullWidth className={classesExtended.selectFormControl}>
                <InputLabel
                  htmlFor="company-list"
                  className={classesExtended.selectLabel}
                  style={{ marginLeft: 0 }}
                >
                  {label.closedCompany}
                </InputLabel>
                <Select
                  MenuProps={{ className: classesExtended.selectMenu }}
                  classes={{ select: classesExtended.select }}
                  inputProps={{
                    name: "companyList",
                    id: "company-list",
                  }}
                >
                  {closedCompanies &&
                    closedCompanies.map((shop) => {
                      return (
                        <MenuItem
                          id={shop.id}
                          key={shop.id}
                          classes={{
                            root: classesExtended.selectMenuItem,
                            selected: classesExtended.selectMenuItemSelectedMultiple,
                          }}
                          value={shop.id}
                        >
                          {shop.name}
                        </MenuItem>
                      )
                    })}
                </Select>
              </FormControl>
            </CardBody>
          </GridItem>
        </GridContainer>
      </HyperModal>
    )
  }

  /**
   * Sociétés ( actives ) ayant publiées
   */
  useEffect(() => {
    setCompaniesAllowedToPublish()
  }, [mpId])

  const setCompaniesAllowedToPublish = (_force = false) => {
    if (mpId && data.dt_from) {
      companyListThatCanPublish(mpId)
        .then((r) => {
          if (r.data.status === 1) {
            let st = r.data?.companyOK
            if (st) {
              let shopsArray = Object.keys(st).map((key) => {
                return st[key]
              })
              if (!_force) {
                let dDay = moment.utc(data.dt_from).isoWeekday() - 1 ?? 0
                openClosedCompanyListByMultiproId(mpId, dDay)
                  .then((r) => {
                    if (r.data.open) {
                      filterJustTheOneOpened(r.data.open, shopsArray)
                    }
                    if (r.data.closed) {
                      setClosedCompanies(r.data.closed)
                    }
                  })
                  .catch((e) => {
                    console.log(
                      "response to open close company went wrong" +
                        mpId +
                        "-" +
                        dDay +
                        "\n" +
                        e
                    )
                  })
              } else setShops(shopsArray)
            } else setDateMode(true)
            let xt = r.data?.companyKO
            if (xt) {
              let koShopsArray = Object.keys(xt).map((key) => {
                return xt[key]
              })
              setUnavailablShops(koShopsArray)
            }
          } else {
            history.replace("/admin/event-list")
            console.log("Something going wrong with company listing")
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }
  }

  const filterJustTheOneOpened = (_p, _allowedShops) => {
    if (_allowedShops) {
      let openOnly = _allowedShops.filter((shop, key) => {
        let id = _p.find((e) => e.id === shop.id)
        if (id && id.id === shop.id) return shop
      })

      openOnly.sort(compareArrayOfObject)
      setShops(openOnly)
    }
  }

  /**
   * Note : Recupering the data if modification state setting null value if not
   */
  useEffect(() => {
    if (modificationEvId) {
      eventDetails(modificationEvId).then((r) => {
        let st = r.data[0]
        console.log("Event to modify :", st)
        setData({ ...data, ...st })

        if (props.location.state?.from === "dashboard") {
          setData({ ...data, cid: props.location.state?.cid })
        }

        setOriginalDate(st.dt_from)

        let legacyCurrentImage =
          st?.ev_id && !st?.original_event_id
            ? BASE_URL + "img/events/cover-" + st?.ev_id + ".jpg"
            : st?.original_event_id
            ? BASE_URL + "img/events/cover-" + st?.original_event_id + ".jpg"
            : undefined

        setCurrentImage(legacyCurrentImage)
        setCoverImage({
          url: legacyCurrentImage,
        })

        console.log("image legacy", legacyCurrentImage)
        setEditorState(
          EditorState.createWithContent(
            ContentState.createFromBlockArray(convertFromHTML(st.details))
          )
        )
      })

      // Charger les images de la galerie
      getImageByEvent(modificationEvId)
        .then((response) => {
          if (response.success && response.images) {
            const cover = response.images.find((img) => img.isCover)
            const gallery = response.images
              .filter((img) => !img.isCover)
              .map((img) => ({
                ...img,
                type: "image",
                isNew: false,
                uploading: false,
              }))

            if (cover) {
              setCoverImage(cover)
              console.log("Cover from API:", cover)
            } else {
              // setCoverImage({
              //   url: `${BASE_URL}img/event/cover-${modificationEvId}.jpg`,
              // })
            }
            setGalleryImages(gallery)
          }
        })
        .catch((error) => {
          console.error("Erreur chargement galerie:", error)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }, [modificationEvId])

  // /**
  //  * Handle closed company when date is set
  //  */
  // useEffect(() => {
  //   if (mpId) {
  //     if (moment(data?.dt_from).isValid()) {
  //       const requestedDate = moment(data?.dt_from).toDate()
  //       openClosedCompanyListByMultiproId(mpId, requestedDate)
  //         .then((response) => {
  //           if (response.status === 200) {
  //             let openedCompanies = response.data.open.map((v) => ({
  //               id: v.id,
  //               name: v.name,
  //             }))
  //             let closedCompanies = response.data.closed.map((v) => ({
  //               id: v.id,
  //               name: v.name,
  //             }))
  //             if (modificationEvId) {
  //               const isEqual = compareArrayOfObject(originalShops, openedCompanies)
  //               if (!isEqual) {
  //                 setShops(openedCompanies)
  //               } else {
  //                 setShops(originalShops)
  //               }
  //             } else {
  //               setShops(openedCompanies)
  //             }
  //           }
  //         })
  //         .catch((e) => console.log(e.response.status, e.response.data.message))
  //     }
  //   }
  // }, [data.dt_from, mpId])

  /**
   * Handle Gallery Files Selected
   */
  const handleGalleryFilesSelected = (filesWithMeta) => {
    const newPendingFiles = filesWithMeta.map((f) => ({
      ...f,
      id: `temp_${Date.now()}_${Math.random()}`,
      isNew: true,
      uploading: false,
    }))
    setPendingGalleryFiles((prev) => [...prev, ...newPendingFiles])
  }

  /**
   * Handle Gallery Remove
   */
  const handleGalleryRemove = (image, index) => {
    if (image.id && !image.isNew) {
      setImagesToDelete((prev) => [...prev, image])
      setGalleryImages((prev) => prev.filter((_, i) => i !== index))
    } else {
      const allImages = [...galleryImages, ...pendingGalleryFiles]
      const targetImage = allImages[index]

      if (targetImage && targetImage.isNew) {
        setPendingGalleryFiles((prev) => prev.filter((f) => f.id !== targetImage.id))

        if (targetImage.preview && targetImage.preview.startsWith("blob:")) {
          URL.revokeObjectURL(targetImage.preview)
        }
      }
    }
  }

  /**
   * Handle Cropped Image
   */
  const handleCroppedImage = async (base64) => {
    if (!base64) return

    try {
      const result = await base64ToFileWithBlobUrl(base64, "cover.jpg")

      if (coverBlobUrl) {
        revokeBlobUrl(coverBlobUrl)
      }

      setCoverBlobUrl(result.blobUrl)
      setNewCoverFile(result.file)
      setShowCropper(false)
    } catch (error) {
      console.error("Erreur conversion image:", error)
    }
  }

  /**
   * Handle Multiple Select
   */
  const handleMultiple = (event) => {
    const selectedValues = event.target.value

    if (selectedValues.includes(label.all) || selectedValues.includes(label.none)) {
      if (multipleSelect.length === shops.length) {
        setMultipleSelect([])
        setData({ ...data, cids: [] })
      } else {
        const allIds = shops.map((shop) => shop.id)
        setMultipleSelect(allIds)
        setData({ ...data, cids: allIds })
      }
    } else {
      setMultipleSelect(selectedValues)
      setData({ ...data, cids: selectedValues })
    }
  }

  /**
   * Handle Input Change
   */
  const handleInputChange = (_value, _entry) => {
    if (_entry === "dt_from") {
      setData({
        ...data,
        dt_from: _value,
        dt_to: _value,
      })
    } else if (_entry === "tarif_normal" || _entry === "tarif_promo") {
      const normal = _entry === "tarif_normal" ? _value : data.tarif_normal
      const promo = _entry === "tarif_promo" ? _value : data.tarif_promo

      if (normal && promo && parseFloat(promo) >= parseFloat(normal)) {
        setTarifError(true)
      } else {
        setTarifError(false)
      }

      setData({ ...data, [_entry]: _value })
    } else {
      setData({ ...data, [_entry]: _value })
    }
  }

  /**
   * Redirect
   */
  const redirect = () => {
    const path = "/admin/event-list"
    history.push({ pathname: path })
  }

  /**
   * ###############################################################################
   *  handleSubmission - NOUVELLE VERSION AVEC GALERIE
   * ###############################################################################
   */
  const handleSubmission = async (_draft = false) => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)

    let stopProcess = false
    let moreInfoText = []

    setLoading(true)

    // Validations
    if (data.cids && data.cids[0] === undefined) {
      stopProcess = true
      moreInfoText.push("- Sélectionnez au moins un établissement")
    }

    if (data.ev_name.length === 0) {
      stopProcess = true
      moreInfoText.push("- Le nom de l'événement est obligatoire")
    }

    if (data.details.length === 0) {
      stopProcess = true
      moreInfoText.push("- La description est obligatoire")
    }

    // Vérifier qu'il y a une cover (nouvelle ou existante)
    const hasCover = newCoverFile || coverImage || currentImage

    if (!modificationEvId && !hasCover) {
      console.log(
        "🚫 Pas de cover pour nouvel événement",
        newCoverFile,
        coverImage,
        currentImage
      )
      stopProcess = true
      moreInfoText.push("- Le visuel est obligatoire")
    }

    if (data.dt_to <= data.dt_from && !data.all_day) {
      stopProcess = true
      moreInfoText.push("- Vérifiez la cohérence des heures")
    }

    if (
      parseFloat(data.tarif) < parseFloat(data.tarif_promo) &&
      data.is_free !== true
    ) {
      stopProcess = true
      moreInfoText.push("- Vérifiez la cohérence de vos tarifs")
    }
    console.log("stopProcess:", stopProcess)
    console.log("moreInfoText:", moreInfoText)
    if (!stopProcess) {
      confirmAlert({
        closeOnClickOutside: false,
        title: "Confirmer",
        message: `Vous ne pourrez plus modifier la date et l'heure de cet événement.`,
        buttons: [
          {
            label: "Je valide",
            onClick: async () => {
              try {
                let eventId = modificationEvId
                let eventIds = []

                // 1️⃣ Créer ou mettre à jour l'événement
                if (modificationEvId) {
                  await updateEvent(data, cid, null, false, _draft, mpId)
                } else {
                  const response = await uploadNewEvent(data, null, _draft, mpId)
                  eventIds = response.data?.lastIds
                }

                // 2️⃣ Suppression des images marquées à supprimer
                if (imagesToDelete.length > 0) {
                  setUploadMessage("Suppression des images...")
                  for (const img of imagesToDelete) {
                    try {
                      await deleteImage("event", eventId, img.id)
                    } catch (error) {
                      console.error("Erreur suppression:", error)
                    }
                  }
                  setImagesToDelete([])
                }

                // 3️⃣ Combiner cover + galerie pour l'upload
                const allFilesToUpload = []
                const filesMetadata = []

                // ✅ Ajouter la nouvelle cover si elle existe
                if (newCoverFile) {
                  allFilesToUpload.push({
                    file: newCoverFile,
                    isCover: true,
                    position: 0,
                  })
                }

                // ✅ Ajouter les fichiers de la galerie
                pendingGalleryFiles.forEach((f, index) => {
                  allFilesToUpload.push({
                    file: f.file,
                    isCover: false,
                    position: galleryImages.length + index + 1,
                  })
                })

                // 4️⃣ Upload si nécessaire
                if (allFilesToUpload.length > 0) {
                  setUploadMessage("Upload des médias...")

                  const files = allFilesToUpload.map((f) => f.file)

                  const uploadedFiles = await uploadMediaToFireStorage(
                    "event",
                    eventId || eventIds[0],
                    files,
                    setUploadProgress,
                    setUploadMessage
                  )

                  if (uploadedFiles.length > 0) {
                    // ✅ Créer les métadonnées en préservant isCover
                    const imagesMetadata = uploadedFiles.map((file, index) => ({
                      path: file.path,
                      url: file.downloadUrl,
                      isCover: allFilesToUpload[index].isCover,
                      position: allFilesToUpload[index].position,
                    }))

                    // Sauvegarder selon le nombre d'événements
                    if (eventIds && eventIds.length > 1) {
                      const metadataPayload = {
                        entityType: "event",
                        eventIds: eventIds,
                        images: imagesMetadata,
                      }

                      await saveImageMetadataBatchMultipleEvents(metadataPayload)
                    } else {
                      const metadataPayload = {
                        entityType: "event",
                        entityId: eventId || eventIds[0],
                        images: imagesMetadata,
                      }
                      console.log("metadataPayload (Just One) :", metadataPayload)
                      await saveImageMetadataBatch(metadataPayload)
                    }

                    // ✅ Nettoyer les états
                    // setPendingGalleryFiles([])
                    setNewCoverFile(null)
                    setCoverBlobUrl(null)
                  }
                }

                // 5️⃣ Notification email
                await notificationByEmailOnEventActionByMultipro(data, mpId)

                // 6️⃣ Succès
                setAlertType("success")
                setInfoText("Bravo, vos modifications ont été enregistrées")
                setSubInfoText(["...et elles sont déjà actives."])
                setLoading(false)
                setShowAlert(true)

                setTimeout(() => {
                  redirect()
                }, 500)
              } catch (error) {
                console.error("Erreur:", error)
                setLoading(false)
                alert("Une erreur est survenue")
              } finally {
                setUploadProgress(0)
                setUploadMessage("")
              }
            },
          },
          {
            label: "Je vérifie encore",
            onClick: () => {
              setLoading(false)
            },
          },
        ],
      })
    } else {
      setAlertType("error")
      setInfoText("Impossible de soumettre le formulaire :")
      setSubInfoText(moreInfoText)
      setLoading(false)
      setShowAlert(true)
    }
  }

  const showInfo = () => {
    setShowAlert(!showAlert)
  }

  // Style construction
  const buttonClasses = useButtonStyles()
  const classes = useStyles()
  const classesExtended = useStylesExtended()
  const classesLocal = useLocalStyle()
  const disabled = useDisabledStyle()

  const allImages = [...galleryImages, ...pendingGalleryFiles]

  return (
    <div className={classesLocal.mainContainer}>
      {!loading ? (
        <div className={classesLocal.contentWrapper}>
          <JAlert
            type={alertType}
            show={showAlert}
            localStatus={showInfo}
            titleText={infoText}
            subTitleText={subInfoText}
          />

          {/* Back Button */}
          <button className={classesLocal.backButton} onClick={redirect}>
            <ArrowBack style={{ fontSize: "20px" }} />
            {label.back}
          </button>

          {/* Header */}
          <div className={classesLocal.headerCard}>
            <div className={classesLocal.pageTitle}>
              <Event style={{ fontSize: "40px", color: "#667eea" }} />
              {label.formTitle}
            </div>
            <p className={classesLocal.pageSubtitle}>{label.formSubtitle}</p>
          </div>

          {/* Info Box */}
          <div className={classesLocal.infoBox}>
            <InfoRounded className={classesLocal.infoIcon} />
            <div>
              <p className={classesLocal.infoText}>{label.infoMessage}</p>
              <a
                href="/faq#menu-6"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#667eea",
                  textDecoration: "none",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                {label.documentation} →
              </a>
            </div>
          </div>

          {/* Warning Box */}
          {unavailableShops && unavailableShops.length > 0 && (
            <div className={classesLocal.warningBox}>
              <Warning className={classesLocal.warningIcon} />
              <p className={classesLocal.warningText}>{label.warning}</p>
            </div>
          )}

          {/* Section 1: Informations principales */}
          <div className={classesLocal.formCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionNumber}>1</div>
              <div style={{ flex: 1 }}>
                <h3 className={classesLocal.sectionTitle}>{label.section1Title}</h3>
              </div>
            </div>

            <GridContainer>
              <GridItem xs={12}>
                <CustomInput
                  labelText={label.name}
                  id="eventName"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    maxLength: 59,
                    type: "text",
                    value: data?.ev_name,
                    onChange: (e) => {
                      handleInputChange(e.target.value, "ev_name")
                    },
                  }}
                />
              </GridItem>

              <GridItem xs={12}>
                <legend style={{ marginBottom: "10px", fontWeight: "500" }}>
                  {label.description}
                </legend>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Editor
                    toolbar={{
                      options: [
                        // "inline",
                        // "blockType",
                        // "fontSize",
                        // "fontFamily",
                        // "list",
                        // "textAlign",
                        // "link",
                        // "embedded",
                        "emoji",
                        "history",
                      ],
                      inline: {
                        inDropdown: false,
                        className: undefined,
                        component: undefined,
                        dropdownClassName: undefined,
                        options: [
                          // "bold",
                          // "italic",
                          // "underline",
                          // "strikethrough",
                          // "monospace",
                          // "superscript",
                          // "subscript",
                        ],
                      },
                    }}
                    editorState={editorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={(editorState) => {
                      setEditorState(editorState)
                      setData({
                        ...data,
                        details: draftToHtml(
                          convertToRaw(editorState.getCurrentContent())
                        ),
                      })
                    }}
                    editorStyle={{
                      display: showCropper ? "none" : "block",
                      backgroundColor: "#dbdcdc",
                      height: "480px",
                      width: "480px",
                    }}
                  />
                </Box>
              </GridItem>
            </GridContainer>
          </div>

          {/* Section 2: Date et horaires */}
          <div className={classesLocal.formCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionNumber}>2</div>
              <div style={{ flex: 1 }}>
                <h3 className={classesLocal.sectionTitle}>{label.section2Title}</h3>
              </div>
            </div>

            <div className={classesLocal.dateContainer}>
              <GridContainer>
                <GridItem xs={12} sm={4}>
                  <FormControl fullWidth>
                    <legend style={{ marginBottom: "10px", fontWeight: "400" }}>
                      {label.dtDay}
                    </legend>
                    <MuiPickersUtilsProvider locale="fr" utils={MomentUtils}>
                      <KeyboardDatePicker
                        disabled={dateMode}
                        clearable
                        value={data?.dt_from ? moment(data?.dt_from).toDate() : ""}
                        placeholder=""
                        onChange={(e) => {
                          let st = moment(e).toDate()
                          handleInputChange(st, "dt_from")
                        }}
                        minDate={new Date()}
                        format="DD/MM/yyyy"
                        okLabel="ok"
                        clearLabel="Effacer"
                        cancelLabel="Annuler"
                        helperText={dateError ? "attention aux heures" : ""}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </GridItem>

                {!!Number(data.all_day) === false ? (
                  <>
                    <GridItem xs={12} sm={4}>
                      <FormControl fullWidth>
                        <legend style={{ marginBottom: "10px", fontWeight: "400" }}>
                          {label.dtStart}
                        </legend>
                        <MuiPickersUtilsProvider locale="fr" utils={MomentUtils}>
                          <KeyboardTimePicker
                            disabled={dateMode}
                            clearable
                            placeholder=""
                            value={data?.dt_from}
                            onChange={(e) => {
                              handleInputChange(moment(e).toDate(), "dt_from")
                            }}
                            ampm={false}
                            okLabel="ok"
                            clearLabel="Effacer"
                            cancelLabel="Annuler"
                            helperText={dateError ? label.dateError : ""}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <FormControl fullWidth>
                        <legend style={{ marginBottom: "10px", fontWeight: "400" }}>
                          {label.dtEnd}
                        </legend>
                        <MuiPickersUtilsProvider locale="fr" utils={MomentUtils}>
                          <KeyboardTimePicker
                            disabled={dateMode}
                            clearable
                            placeholder=""
                            value={data?.dt_to}
                            onChange={(e) => {
                              handleInputChange(moment(e).toDate(), "dt_to")
                            }}
                            ampm={false}
                            okLabel="ok"
                            clearLabel="Effacer"
                            cancelLabel="Annuler"
                            helperText={dateError ? label.dateError : ""}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </GridItem>
                  </>
                ) : null}

                <GridItem xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        disabled={dateMode}
                        checked={!!Number(data.all_day)}
                        onChange={(e) => {
                          handleInputChange(e.target.checked ? 1 : 0, "all_day")
                        }}
                        value={!!Number(data.all_day)}
                        classes={{
                          switchBase: classesLocal.switchBase,
                          checked: classesLocal.switchChecked,
                          thumb: classesLocal.switchIcon,
                          track: classesLocal.switchBar,
                        }}
                      />
                    }
                    classes={{
                      label: classesLocal.label,
                    }}
                    label={label.allTheDay}
                  />
                </GridItem>

                <GridItem xs={12}>
                  <Button
                    color={forceItOverHolliday ? "warning" : "github"}
                    size="sm"
                    onClick={() => {
                      setForceItOverHolliday(!forceItOverHolliday)
                      setCompaniesAllowedToPublish(!forceItOverHolliday)
                    }}
                    simple={true}
                  >
                    <div style={{ alignContent: "center" }}>
                      <Warning className={buttonClasses.icons} />
                      {label.forceItAll}
                    </div>
                  </Button>
                </GridItem>

                {forceItOverHolliday === false && (
                  <GridItem xs={3}>
                    {closedCompanies && closedCompanies.length > 0 ? (
                      <ClosedCompanyListModal closedCompanies={closedCompanies} />
                    ) : (
                      <Button color="github" size="sm" simple={true}>
                        <div style={{ alignContent: "center" }}>
                          <Store className={buttonClasses.icons} />{" "}
                          {label.noneShopClosed}
                        </div>
                      </Button>
                    )}
                  </GridItem>
                )}
              </GridContainer>
            </div>
          </div>

          {/* Section 3: Tarification */}
          <div className={classesLocal.formCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionNumber}>3</div>
              <div style={{ flex: 1 }}>
                <h3 className={classesLocal.sectionTitle}>{label.section3Title}</h3>
              </div>
            </div>

            <GridContainer>
              <GridItem xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!Number(data.is_free)}
                      onChange={(e) => {
                        handleInputChange(e.target.checked ? 1 : 0, "is_free")
                      }}
                      value={!!Number(data.is_free)}
                      classes={{
                        switchBase: classesLocal.switchBase,
                        checked: classesLocal.switchChecked,
                        thumb: classesLocal.switchIcon,
                        track: classesLocal.switchBar,
                      }}
                    />
                  }
                  classes={{
                    label: classesLocal.label,
                  }}
                  label={label.freely}
                />
              </GridItem>

              {!!Number(data.is_free) === false ? (
                <>
                  <GridItem xs={6} sm={2}>
                    <CustomInput
                      labelText={label.tarif}
                      id="tarif"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: data?.tarif,
                        onChange: (e) => {
                          handleInputChange(e.target.value, "tarif")
                        },
                      }}
                    />
                  </GridItem>

                  <GridItem xs={6} sm={2}>
                    <CustomInput
                      labelText={label.tarifPromo}
                      id="tarifPromo"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: data?.tarif_promo,
                        onChange: (e) => {
                          handleInputChange(e.target.value, "tarif_promo")
                        },
                      }}
                    />
                    {tarifError && (
                      <p className={classesLocal.textError}>{label.tarifError}</p>
                    )}
                  </GridItem>
                </>
              ) : null}
            </GridContainer>
          </div>

          {/* Section 4: Établissements concernés */}
          <div className={classesLocal.formCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionNumber}>4</div>
              <div style={{ flex: 1 }}>
                <h3 className={classesLocal.sectionTitle}>{label.section4Title}</h3>
              </div>
            </div>

            <GridContainer>
              <GridItem xs={12}>
                <FormControl fullWidth className={classesExtended.selectFormControl}>
                  <InputLabel
                    htmlFor="company-list"
                    className={classesExtended.selectLabel}
                    style={{ marginLeft: 0 }}
                  >
                    {label.companies}
                  </InputLabel>
                  <Select
                    multiple
                    value={multipleSelect}
                    onChange={handleMultiple}
                    MenuProps={{ className: classesExtended.selectMenu }}
                    classes={{ select: classesExtended.select }}
                    inputProps={{
                      name: "companyList",
                      id: "company-list",
                    }}
                  >
                    <MenuItem
                      classes={{
                        root: classesExtended.selectMenuItem,
                      }}
                      value={
                        multipleSelect.length === shops.length
                          ? label.none
                          : label.all
                      }
                    >
                      {multipleSelect.length === shops.length
                        ? label.none
                        : label.all}
                    </MenuItem>
                    {shops.map((shop) => {
                      return (
                        <MenuItem
                          id={shop.id}
                          key={shop.id}
                          classes={{
                            root: classesExtended.selectMenuItem,
                            selected: classesExtended.selectMenuItemSelectedMultiple,
                          }}
                          value={shop.id}
                        >
                          {shop.name}
                        </MenuItem>
                      )
                    })}
                    <Divider />
                    {unavailableShops &&
                      unavailableShops.map((shop) => {
                        return (
                          <MenuItem
                            id={shop.id}
                            key={shop.id}
                            disabled={modificationEvId === false ? true : false}
                            classes={{
                              root: classesExtended.disabledMenuItem,
                              selected:
                                classesExtended.selectMenuItemSelectedMultiple,
                            }}
                            value={shop.id}
                          >
                            {shop.name}
                          </MenuItem>
                        )
                      })}
                  </Select>
                  <p style={{ marginTop: 20, fontStyle: "italic" }}>
                    vous avez choisi{" "}
                    {data && data.cids && data?.cids[0] ? data.cids.length : 0}{" "}
                    établissement(s) sur {shops && shops.length > 0 && shops.length}
                  </p>
                </FormControl>
              </GridItem>
            </GridContainer>
          </div>

          {/* Section 5: Médias */}
          <div className={classesLocal.formCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionNumber}>5</div>
              <div style={{ flex: 1 }}>
                <h3 className={classesLocal.sectionTitle}>{label.section5Title}</h3>
              </div>
            </div>
            {/* Info Box */}
            <div className={classesLocal.infoBox}>
              <InfoRounded className={classesLocal.infoIcon} />
              <div>
                <p className={classesLocal.infoText}>{label.infoMedia}</p>
              </div>
            </div>
            <GridContainer>
              {/* Visuel Principal */}
              <GridItem xs={12} sm={6}>
                <div className={classesLocal.visualContainer}>
                  <img
                    src={
                      coverBlobUrl ??
                      coverImage?.url ??
                      currentImage ??
                      placeHolder.default
                    }
                    alt="Événement"
                    className={classesLocal.visualImage}
                  />
                  <button
                    className={classesLocal.visualButton}
                    onClick={() => {
                      setShowCropper(!showCropper)
                    }}
                  >
                    <InsertPhoto style={{ fontSize: "20px" }} />
                    {label.visuelChoice}
                  </button>
                </div>
              </GridItem>

              {/* Galerie */}
              <GridItem xs={12} sm={6}>
                <GalleryUploader
                  images={allImages}
                  onFilesSelected={handleGalleryFilesSelected}
                  onRemoveImage={handleGalleryRemove}
                  title="Galerie de l'événement"
                  maxMedias={MAX_MEDIA_GALLERY}
                  disabled={loading}
                  progress={uploadProgress}
                  progressMessage={uploadMessage}
                />
              </GridItem>
            </GridContainer>
          </div>

          {/* Submit Buttons */}
          <div
            style={{ textAlign: "center", marginTop: "32px", marginBottom: "32px" }}
          >
            <GridContainer justify="center" spacing={2}>
              <GridItem>
                <button
                  className={classesLocal.submitButton}
                  onClick={() => {
                    handleSubmission(false)
                  }}
                >
                  <Favorite style={{ fontSize: "20px" }} />
                  {label.publish}
                </button>
              </GridItem>
              {/*  <GridItem>*/}
              {/*    <button*/}
              {/*      className={classesLocal.submitButton}*/}
              {/*      style={{*/}
              {/*        background: "linear-gradient(135deg, #64748b 0%, #475569 100%)",*/}
              {/*      }}*/}
              {/*      onClick={() => {*/}
              {/*        handleSubmission(true)*/}
              {/*      }}*/}
              {/*    >*/}
              {/*      <Drafts style={{ fontSize: "20px" }} />*/}
              {/*      {label.draftBtn}*/}
              {/*    </button>*/}
              {/*  </GridItem>*/}
            </GridContainer>
          </div>

          <CropperX
            visibility={showCropper}
            backInfo={() => setShowCropper(!showCropper)}
            title={label.eventPic}
            image={coverImage?.url}
            b64={handleCroppedImage}
            direction="row"
          />
        </div>
      ) : (
        <div className={disabled.disabledBack}>
          <GridLoader
            color="#3f4850"
            loading={loading}
            size={50}
            css={`
              position: absolute;
              display: block;
              z-index: 999;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            `}
          />
        </div>
      )}
    </div>
  )
}
